export default __webpack_public_path__ + "static/media/4456.0615a4fe.jpg";